import StatsCard from "../components/StatsCard";
import Layout from "../layouts/layout";
import styles from "../styles/_screens/dashboard.module.scss";

const Dashboard = () => {
  return (
    <Layout>
      <div className={styles.container}>
        <h1>Ben Gurion Management System</h1>

        <div className={styles.cards}>
          <StatsCard
            name="Income in shekels for today"
            value={`₪6405`}
            img="/assets/income.svg"
          />
          <StatsCard
            name="Number of Visitors this Month"
            value={`400`}
            img="/assets/visitors.svg"
          />
          <StatsCard
            name="Number of Orders this Month"
            value={`62`}
            img="/assets/ordersMonth.svg"
          />
          <StatsCard
            name="Number of Orders Today"
            value={`8`}
            img="/assets/ordersToday.svg"
          />
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
